import styled from 'styled-components';
import { ALBUM_GAP } from './const';

export const AlbumWrapper = styled.div<{ maxWidth?: string }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${ALBUM_GAP}px;
`;

export const AlbumBackgroundVideoWrapper = styled.div<{ width: number; height: number }>`
    border-radius: 8px;
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    video {
        height: 100%;
    }
`;

export const AlbumBackgroundImage = styled.div<{ uri: string }>`
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('${(props) => props.uri}');
    transition: all 0.8s;
    :hover {
        scale: 1.04;
        transition: all 0.4s;
    }
`;

export const AlbumImageWrapper = styled.div<{ width: number; height: number }>`
    border-radius: 8px;
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`;

export const AlbumImage = styled.img`
    flex-shrink: 0;
    min-width: 100%;
    min-height: 100%;
    transition: all 0.8s;
    :hover {
        scale: 1.04;
        transition: all 0.4s;
    }
`;

export const AlbumOverlay = styled.div`
    border-radius: 8px;
    position: absolute;
    inset: 0;
    background: ${(props) => props.theme.color.black20};
    color: ${(props) => props.theme.color.white};
    font-size: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
`;

export const AlbumAttachments = styled.div`
    margin-top: ${ALBUM_GAP}px;
`;

export const AlbumRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${ALBUM_GAP}px;
`;

export const AlbumX1Wrapper = styled.div`
    position: relative;
    display: flex;
`;

export const AlbumButton = styled.button``;
